import { render, staticRenderFns } from "./winTeam_T.vue?vue&type=template&id=32254fb7&scoped=true"
import script from "./winTeam_T.vue?vue&type=script&lang=js"
export * from "./winTeam_T.vue?vue&type=script&lang=js"
import style0 from "./winTeam_T.vue?vue&type=style&index=0&id=32254fb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32254fb7",
  null
  
)

export default component.exports